export interface PersonalTier {
  name: string;
  price: string;
  priceNote?: string;
  body: string;
  highlighted?: boolean;
}

export const personalTiers: readonly PersonalTier[] = [
  {
    name: "One course",
    price: "$49",
    body: "Pick the single problem in front of you and start there.",
  },
  {
    name: "Certification",
    price: "$129",
    body: "Three courses that work together, plus a certificate you can show.",
  },
  {
    name: "Unlimited",
    price: "$349",
    priceNote: "per year",
    body: "Every course and certification plus personalized support from a Development Pro.",
    highlighted: true,
  },
];

export const personalAddOn: PersonalTier = {
  name: "Unlimited asynchronous coaching",
  price: "$499",
  priceNote: "per year",
  body: "For genuinely hard situations, when you want a real person in your corner.",
};

export const pricingFootnote = "Prices are per person. Annual plans billed yearly.";
